import { User } from "firebase"
import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { Errors } from "../../typings/interfaces";
import { useHistory, useParams } from "react-router";
import firebase from '../../firebase';
import isNil from "lodash/isNil";
import { pickBy } from "lodash";
import ImageUploader from "../../common/ImageUploader";
import { v4 as uuidv4 } from 'uuid';
import { OverviewPage } from "./OverviewPage";
import { ItemDetailsPage } from "./ItemDetailsPage";
import { DistributionPage } from "./DistributionPage";

const db = firebase.firestore();

interface ProductProps {
  user: User;
}

enum ProductEditPage {
  OVERVIEW = 'Product Overview',
  DETAILS = 'Item Details',
  DISTRIBUTION = 'Distribution'
};

export const ProductEdit = ({user}: ProductProps) => {
  const history = useHistory();
  const { id } = useParams();
  const [product, setProduct] = useState<firebase.firestore.DocumentData>({} as unknown as  firebase.firestore.DocumentData);
  const [page, setPage] = useState<ProductEditPage>(ProductEditPage.OVERVIEW);

  useEffect(() => {
    if (!isNil(user) && !isNil(id)) {
      const productDoc = db.collection("products").doc(id);
        
      // listen for document changes
      productDoc.onSnapshot(docSnaphot => {
        const docData = docSnaphot.data();
        if (!isNil(docData)) {
          setProduct(docData);
        }
      });

      // unregister document listner
      return () => productDoc.onSnapshot(() => {})();
    }     
  }, [user, id]);

  let imagePath = product.img || ('brand-assets/' + user.uid + '/images/' + uuidv4());

  const isLastPage = page === ProductEditPage.DISTRIBUTION;
  return (
    <div className='product-form'>
      <div className='logo-container'>
        <ImageUploader className="uploader" filePath={imagePath} message='+ Upload Image'/>
      </div>
      <Formik
        enableReinitialize
        initialValues={{ 
          name: product.name ?? '', 
          sku: product.sku ?? '',
          category: product.category ?? '', 
          description: product.description ?? '',
          cost: product.cost ?? '',
          price: product.price ?? '',    
          usp: product.usp ?? [],      
          certifications: product.certifications ?? [],
          barcodeType: product.barcodeType ?? '',
          barcode: product.barcode ?? '',
          state: product.state ?? '',
          retailers: product.retailers ?? [],
          distributors: product.distributors ?? [],
        }}
        validate={values => {
          const errors: Errors = {};
          if (!values.name) {
            errors.name = 'Required';
          }
          return errors;
        }}
        onSubmit={(values, { setSubmitting, setTouched }) => {
          if (page === ProductEditPage.DISTRIBUTION) {
            const update = Object.assign({}, pickBy(values), {
              uid: user.uid,
              img: imagePath
            });
            
            if (isNil(id)) {
              db.collection('products').add(update).then(ref => {
                history.push(`/products/edit/${ref.id}`);
              });
            } else {
              db.collection('products').doc(id).set(update);
            }
            history.push("/");
          } else {
            setTouched({});
            setSubmitting(false);
            switch (page) {
              case ProductEditPage.OVERVIEW:
                setPage(ProductEditPage.DETAILS);
                break;
              case ProductEditPage.DETAILS:
                setPage(ProductEditPage.DISTRIBUTION);
                break;
              default:
                setPage(ProductEditPage.OVERVIEW);
                break;
            }
          }
        }}
      >
        {({ isSubmitting }) => (
          <Form className='profile-form'>
            {(() => {
              switch(page) {
                case ProductEditPage.OVERVIEW:
                  return <OverviewPage />;
                case ProductEditPage.DETAILS:
                  return <ItemDetailsPage />;
                case ProductEditPage.DISTRIBUTION:
                  return <DistributionPage />;
                default:
                  return <OverviewPage />;
              }
            })()}

            {
              !isLastPage && 
              (<button className='button' type="submit" disabled={isSubmitting}>Next</button>)
            }
            {
              isLastPage && 
              (<button className='button' type="submit" disabled={isSubmitting}>
                Submit
              </button>)
            }
          </Form>
        )}
      </Formik>
    </div>
  );
}

